import React from 'react';
import { Link } from 'react-scroll';
import './Header.css';

const Header = () => {

    return (
        <header className="navbar">
            <Link to = "Home" spy={true} smooth={true} offset={-96} duration={500}>
                <button>Home</button>
            </Link>
            <Link to = "ProjectsPage" spy={true} smooth={true} offset={-96} duration={500} >
                <button>Projects</button>
            </Link>
            <Link to = "Blog" spy={true} smooth={true} offset={-96} duration={500} >
                <button>Blog</button>
            </Link>
            <Link to = "Contact" spy={true} smooth={true} offset={-96} duration={500} >
                <button>Contact</button>
            </Link>
        </header>
    );
};

export default Header;